var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgTwitter = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.337,
    height: 22,
    viewBox: "0 0 24.337 22",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Twitter_X-branco",
    "data-name": "Twitter X-branco",
    d: "M45.965,48H49.7l-8.155,9.318L51.138,70h-7.51l-5.886-7.689L31.015,70H27.276L36,60.031,26.8,48h7.7l5.315,7.028ZM44.654,67.768h2.068L33.374,50.115H31.152Z",
    transform: "translate(-26.8 -48)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTwitter, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/twitter.0b597216.svg";
export { ForwardRef as ReactComponent };